import { useState } from "react"
import { useTranslation } from "react-i18next"
import Loading from "components/commons/Loading"
import { useLazyGetAnonymousWhistleQuery } from "../api/whistleApiSlice"
import WhistleCard from "./WhistleCard"

function FetchAnonymousWhistleModal({
    onSuccess = () => { }
}) {

    const [t, i18n] = useTranslation(["global", "whistle"])
    const [code, setCode] = useState('')
    const [trigger,
        {
            data: response,
            isFetching,
            isSuccess,
            isError,
        }
    ] = useLazyGetAnonymousWhistleQuery()

    return (
        <>
            <button type="button w-100" className="btn btn-black" data-bs-toggle="modal" data-bs-target="#fetchAnonymousWhistle">
                <a className="nav-link"><i className="fa-solid fa-magnifying-glass"></i>  {t("whistle:action.fetch_anonymous_warning")}</a>
            </button>

            <div className="modal fade" id="fetchAnonymousWhistle" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content bg-dark text-white">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{t("whistle:action.fetch_anonymous_warning")}</h5>
                            <button type="button" className="btn-close bg-light" id="closeButton" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-start">
                            <p>{t("whistle:helper.insert_warning_code")}</p>
                            <form>
                                <div className="row">
                                    <div className="col-3 text-end">
                                        <h2><i className="fa-solid fa-key"> </i></h2>
                                    </div>
                                    <div className="col-4">
                                        <input type="text" className="form-control" id="keyCode" placeholder={t("whistle:placeholder.code")} value={code} onChange={(e) => setCode(e.target.value)} />
                                    </div>
                                    <div className="col-5">
                                        {isFetching ?
                                            <Loading />
                                            :
                                            <button type="submit" onClick={() => { trigger(code) }} className={`btn btn-primary ${code.length > 3 ? null : "disabled"} `} >{t("whistle:action.fetch")}</button>
                                        }
                                    </div>
                                </div>
                            </form>
                            <div className="mt-2">
                                {

                                    isFetching == false && isSuccess && <WhistleCard whistle={response} />
                                }
                                {
                                    isFetching == false && isError &&
                                    <div className="text-center p-2">
                                        <h6><i className="fa-solid fa-circle-exclamation text-danger"></i> {t("whistle:helper.no_report_found")}</h6>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default FetchAnonymousWhistleModal